import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { useFeature } from '@growthbook/growthbook-react';
import useRequestConfig from './useRequestConfig';
import { getAPI } from '../../services/API';
import { isLoggedInSelector } from '../../redux/reducers/app/params';
import { FEATURES } from '../../constants/featureToggling';
import { sdkErrorHandler } from '../../utils';

export const QUERY_KEY_JACKPOT = 'jackpot-data';

export const useQueryJackpot = (queryOptions) => {
  const isEnabledJackpots = useFeature(FEATURES.ENABLE_JACKPOT_TICKER).on;

  const isLoggedIn = useSelector(isLoggedInSelector);
  const cacheTime = isLoggedIn ? 1000 * 60 * 3 : 0;

  const requestConfig = useRequestConfig();

  const fetch = ({ signal }) =>
    getAPI()
      .jackpot.get({ signal, ...requestConfig })
      .catch(
        sdkErrorHandler({
          ...requestConfig,
          queryOptions,
          source: `SDK API jackpot.get`,
        })
      );

  return useQuery([QUERY_KEY_JACKPOT, requestConfig.headers], fetch, {
    enabled: Boolean(isEnabledJackpots),
    cacheTime,
    ...queryOptions,
  });
};
